<template>
  <main class="page-test">
    <div class="container-wide">
      <h1>Test page</h1>
      <div class="test-block token-block">
        <div class="caption">Token</div>
        <b-field>
          <b-input type="password" v-model="token" placeholder="token"></b-input>
        </b-field>
      </div>
      <div class="test-block">
        <div class="caption">Send test error (for Sentry testing)</div>
        <b-field>
          <b-input v-model="errorText" placeholder="error text"></b-input>
        </b-field>
        <b-button type="is-primary" @click="sendTestError">
          <div class="button-inner">
            Send
          </div>
        </b-button>
      </div>
    </div>
  </main>
</template>

<script lang="ts">

import VueMq from "vue-mq";
import { Component, Vue } from "vue-property-decorator";
import HelperService from "@/services/HelperService";
import { Meta } from "../decorators/MetaDecorator";

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 992,
    lg: Infinity,
  },
  defaultBreakpoint: "sm",
});

@Component({
  components: { },
})
export default class TestPage extends Vue {

  @Meta
  myMetaConfig() {
    return {
      title: "Test page"
    };
  }

  //#region Properties

  private TOKEN_VALUE = "uco12345";

  errorText = "";
  token = "";

  //#endregion Properties


  //#region Handlers

  sendTestError() {
		if (!this.token || this.token !== this.TOKEN_VALUE) {
      HelperService.showError("Enter token");
			return;
		}
		if (!this.errorText) {
      HelperService.showError("Enter error text");
			return;
		}
		throw new Error(this.errorText);
	}

  //#endregion Handlers
}

</script>

<style lang="scss" scoped>
.page-test {

  h1 {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0;
  }
  
  .test-block {
    border: 1px solid #ddd;
    margin-bottom: 1rem;
    padding: 1rem;

    &.token-block {
      input {
        margin-bottom: 0;
      }
    }

    .caption {
      font-weight: bold;
      margin-bottom: 1rem;
    }
  }
}
</style>
